import { atomWithStorage } from 'jotai/utils'

export const desktopNavigationExpandAtom = atomWithStorage<boolean>(
  'desktopNavigationExpand',
  true,
  undefined,
  { getOnInit: true },
)
